import React from 'react';
import PropTypes from 'prop-types';

import DocumentModal from './document_modal.jsx';
import Grid from 'realize_overrides/components/grid/grid';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentModalIds from '../../constants/document_modal_ids';
import DocumentLocks from '../../constants/document_locks';
import { DocumentActions } from '../../reflux/document_store';
import { documentIsLockedBy } from '../../helpers/document_helper.js'
import { serializePrivateProperties } from '../../../utils/object_utils.js';

import TableCellRenderFactory from '../../../grid/table_cell_render_factory.js'


const Realize = {
	i18n: window.Realize.i18n,
	Flash: window.Flash,
	Grid: Grid
};

export default class HandleDuplicateDocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		title: 'template.titles.handleDuplicate',
		className: 'handle-duplicate-document-modal',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
		this.handleDuplicateDocumentsGridSelection = this.handleDuplicateDocumentsGridSelection.bind(this);
		this.handleDuplicateDocumentsGridRowClick = this.handleDuplicateDocumentsGridRowClick.bind(this);
		this.overridableDocumentCriteria = this.overridableDocumentCriteria.bind(this);
	}

	componentDidMount(){
		setTimeout(() => {
			this.tabMessageModal();
			this.tabGridModal();
		}, 800);
	}

	componentDidUpdate() {
		if(this.selectedDuplicateDocument) {
			this.setDuplicateDocumentsGridSelection();
		} else {
			this.clearDuplicateDocumentsGridSelection();
		}
		// setTimeout(() => { $('.button-create-document').off('keydown'); }, 500)
	}

	get waitingForAction() {
		return this.props.store.waitingForAction;
	}

	get duplicateDocuments() {
		return this.props.store.duplicateDocuments.map(function(duplicateDocument) {
			return serializePrivateProperties(duplicateDocument);
		}, this);
	}

	get selectedDuplicateDocument() {
		return this.props.store.selectedDuplicateDocument;
	}

	tabMessageModal(){
		let messageModal = $('#handle-duplicate-document .flash__content p');
		messageModal.attr('tabindex', '0');
	}

	tabGridModal(){
		let idModalDocVisible = $('#documentModal').is(':visible');

		if(idModalDocVisible === true){
			let tableRowGrid = $('.grid-duplicate-document .grid__table tbody .clickable-row');
			let titleModal = $('#documentModal .with-title');

			titleModal.unbind('keydown').keydown((e) => {
				if(e.shiftKey){
					return false
				}
			});

			if(tableRowGrid.length > 0){
				let checkboxGrid = $('.grid-duplicate-document .grid__table tbody .clickable-row td label');
				let row = $('.clickable-row');

				row.attr('tabindex', '0');
				checkboxGrid.attr('tabindex', '0');
				// row[0].focus();
				$("#documentModal .h5-custom")[0].focus()

				checkboxGrid.unbind('keydown').keydown((e) => {
					if(e.which === 32 || e.keyCode === 32){
						e.currentTarget.click();
						// e.currentTarget.childNodes[0].childNodes[1].click();
					}
				});
			}

			this.focusButtonsModal();
		}
	}

	focusButtonsModal(){
		let btnClose = $('.button-close-modal-document');
		let btnDuplicarDoc = $('.duplicar-documento');
		let titleModal = $('#documentModal .with-title span');

		btnClose.attr('tabindex', '0');
		btnDuplicarDoc.attr('tabindex', '0');

		btnDuplicarDoc.unbind('keydown').keydown((e) => {
			if(!e.shiftKey && e.which === 9){
				// let row = $('.clickable-row');
				titleModal[0].focus();
				return false
			}

			if(e.which === 13){
				btnDuplicarDoc[0].click();
			}
		});

	}

	overridableDocumentCriteria(document) {
		return !documentIsLockedBy(document, DocumentLocks.OVERRIDE);
	}

	handleDuplicateDocumentsGridSelection(event, rowDocumentId, rowDocument) {
		const elem = $(event.currentTarget.parentElement);
		const input = elem.find('input')[0];

		if(input){
			const checked = input.checked;
			event.currentTarget.setAttribute('aria-checked', !checked);
			event.currentTarget.setAttribute('role', 'checkbox');
		}

		DocumentActions.selectDuplicateDocument(this.props.id, rowDocument);
	}

	handleDuplicateDocumentsGridRowClick(event, rowDocument) {
		if(documentIsLockedBy(rowDocument, DocumentLocks.OVERRIDE))
			return;

		const gridRef = this.refs.grid;
		const selectedDocumentId = gridRef.state.selectedRowIds[0];
		const documentId = rowDocument.id;
		DocumentActions.selectDuplicateDocument(this.props.id, (selectedDocumentId == documentId) ? null : documentId);
	}

	clearDuplicateDocumentsGridSelection() {
		const gridRef = this.refs.grid;
		gridRef.setState({ selectedRowIds: [] });
	}

	setDuplicateDocumentsGridSelection() {
		const gridRef = this.refs.grid;
		gridRef.setState({ selectedRowIds: [this.selectedDuplicateDocument.id] });
	}

	buildDuplicateDocumentsGridData() {
		return{
			dataRows: this.duplicateDocuments,
			count: this.duplicateDocuments.length
		}
	}

	buildDuplicateDocumentsGridColumns() {
		return {
			version: {
				label: Realize.i18n.t('template.attributes.currentVersion'),
				name: "version",
				format: "text",
				component: TableCellRenderFactory,
				visible: true
			},
			fileName: {
				label: Realize.i18n.t('template.attributes.fileName'),
				name: "fileName",
				format: "text",
				component: TableCellRenderFactory,
				visible: true
			}
		};
	}

	render() {
		return (
			<div className="handle-duplicate-document__content">
				<div className="handle-duplicate-document__message row" id="handle-duplicate-document">
					<Realize.Flash
						message={Realize.i18n.t('template.messages.handleDuplicate')}
						canDismiss={false}
					/>
				</div>
				<div className="handle-duplicate-document__grid">
					<Grid
						className="grid-duplicate-document"
						url=""
						clientSide={true}
						selectable="none"
						paginationOnTop={false}
						data={this.buildDuplicateDocumentsGridData()}
						columns={this.buildDuplicateDocumentsGridColumns()}
						actionButtons={{member: [], collection: []}}
						paginationConfigs={{perPage: 10}}
						rowSelectableFilter={this.overridableDocumentCriteria}
						onSelectDataRow={this.handleDuplicateDocumentsGridSelection}
						onClickRow={this.handleDuplicateDocumentsGridRowClick}
						contextType='TEMPLATE'
						ref="grid"
						typeScreen="duplicate-document"
					/>
				</div>
			</div>
		);
	}
}
